import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "Layer_2",
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "20",
  viewBox: "0 0 12 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".cls-1{fill:#000;stroke-width:0px;}")
        ])),
        _: 1,
        __: [0]
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", { id: "Layer_1-2" }, [
      _createElementVNode("path", {
        class: "cls-1",
        d: "M10.67,0H1.33c-.35,0-.69.15-.94.42-.25.27-.39.64-.39,1.02v15.84c0,.13.03.25.09.37.06.11.15.2.25.26.1.06.22.09.34.09.12,0,.23-.04.34-.11l4.98-3.36,4.98,3.36c.1.07.22.11.34.11.12,0,.24-.03.34-.09.1-.06.19-.15.25-.26.06-.11.09-.24.09-.36V1.44c0-.38-.14-.75-.39-1.02-.25-.27-.59-.42-.94-.42ZM10.67,1.44v10.22l-4.31-2.91c-.11-.07-.23-.11-.35-.11s-.25.04-.35.11l-4.31,2.91V1.44h9.33ZM6.35,13.07c-.11-.07-.23-.11-.35-.11s-.25.04-.35.11l-4.31,2.91v-2.62l4.67-3.15,4.67,3.15v2.62l-4.31-2.91Z"
      })
    ], -1))
  ]))
}
export default { render: render }